import _ from 'lodash';
import { detectMobileDevice, paramaterize } from 'utils';
import errorReporter from '@app/errorReporter';
import { areAppointmentInstructionsInvalid } from './areAppointmentInstructionsInvalid';
import template from './appointment_status_change.html';

angular.module('bb.appointments').component('bbAppointmentStatusChange', {
  bindings: {},
  controller: AppointmentStatusChangeCtrl,
  controllerAs: 'vm',
  template,
});

AppointmentStatusChangeCtrl.$inject = [
  '$rootScope',
  '$location',
  '$q',
  '$routeParams',
  'AppointmentBookService',
  'AppointmentConfigService',
  'AppointmentSearchService',
  'AppointmentStatusService',
  'ToastService',
];

function AppointmentStatusChangeCtrl(
  $rootScope,
  $location,
  $q,
  $routeParams,
  AppointmentBookService,
  AppointmentConfigService,
  AppointmentSearchService,
  AppointmentStatusService,
  ToastService,
) {
  const PAST_TENSE_MAP = {
    confirm: 'confirmed',
    cancel: 'cancelled',
    deny: 'denied',
  };

  const vm = this;
  vm.mobileView = detectMobileDevice();
  vm.instructionToAccess = {
    none: {
      id: '',
      label: $rootScope.hasFeature('SUPRA_MVP') ? 'Unassign' : '',
    },
    lockbox: { id: 'Lock Box', label: 'Combination Lock Box' },
    direct: { id: 'Direct', label: 'Direct' },
    key: { id: 'Key', label: 'Key' },
    doorcode: { id: 'Door Code', label: 'Door Code' },
  };

  vm.newStatus = $routeParams.status;
  vm.details = {};

  vm.back = () => {
    const backPath = `listing/${vm.data.listing.id}/appointments`;
    $location.path(backPath);
  };

  vm.setDenyTime = () => {
    vm.data.appointment.details = `Please book for ${
      vm.selectedTimeOption
    } ${moment(vm.selectedTime).format('h:mm a')}`;
  };

  vm.setStatus = () => {
    vm.details.message = vm.data.appointment.details;
    if (vm.newStatus === 'confirm') {
      vm.details.instructions = vm.appointmentConfig.instructions;
      vm.details.access = vm.appointmentConfig.access;
    }
    vm.dataLoaded = false;
    return AppointmentStatusService.saveAppointmentStatus({
      detailsType: vm.newStatus,
      appointmentId: vm.data.appointment.id,
      details: vm.details,
      isPending: vm.data.appointment.notify.office,
    })
      .then(() => {
        if (vm.newStatus === 'confirm') {
          swal({
            title: 'Showing Confirmed!',
            text: 'The showing has been successfully confirmed',
            type: 'success',
            confirmButtonText: 'Ok',
            closeOnConfirm: true,
            showCancelButton: false,
          });
        }
        const savePath = `listing/${vm.data.listing.id}/appointments`;
        $location.url(savePath);
      })
      .catch(err => {
        errorReporter.error(err);
        vm.errorMessage = err.data.message;
        vm.dataLoaded = true;
      });
  };

  vm.validConfirmation = () => {
    if (!vm.appointmentConfig) return false;
    switch (vm.appointmentConfig.access) {
      case 'Lock Box':
        return (
          vm.appointmentConfig.instructions.lockbox.code ||
          vm.appointmentConfig.instructions.lockbox.details
        );
      case 'Key':
        return !!vm.appointmentConfig.instructions.key.details;
      case 'Door Code':
        return (
          vm.appointmentConfig.instructions.doorcode.code ||
          vm.appointmentConfig.instructions.doorcode.details
        );
      case 'SentriLock':
        return vm.validSentriLockRange() && vm.isSentriLockCodeValid;
      case 'MasterLock':
        return !!vm.appointmentConfig.instructions.masterlock.deviceId;
      case 'SentriLockV2':
        return !!vm.appointmentConfig.instructions.sentrilockv2.lbsn;
      case 'Direct':
      case 'SentriLock App':
      case 'Supra eKEY':
        return true;
      default:
        return false;
    }
  };

  vm.onMasterLockValidate = (deviceId = null) => {
    vm.appointmentConfig.instructions.masterlock.deviceId = deviceId;
  };

  vm.validSentriLockRange = () => {
    return (
      vm.appointmentConfig?.instructions?.sentrilock?.lbsn &&
      vm.appointmentConfig.instructions.sentrilock.lbsn.length >= 6 &&
      vm.appointmentConfig.instructions.sentrilock.lbsn.length <= 10
    );
  };

  vm.withinSentriLockDate = () => {
    if (
      vm.appointmentConfig &&
      (vm.appointmentConfig.access === 'SentriLock' ||
        (vm.appointmentConfig.access === 'SentriLockV2' &&
          vm.appointmentConfig.instructions.sentrilockv2.isOneDayCodeEnabled))
    ) {
      return (
        moment(vm.data.appointment.time) < moment().add(14, 'days').endOf('day')
      );
    }
    return true;
  };

  vm.validateSentriLock = lbsn => {
    vm.validatingSentriLock = true;
    AppointmentStatusService.validateSentrilock({
      listingId: vm.appointmentConfig.listingId,
      lbsn,
      date: moment().format('YYYY-MM-DD'),
    })
      .then(({ valid }) => {
        vm.isSentriLockCodeValid = valid;
      })
      .catch(errorReporter.error)
      .finally(() => {
        vm.validatingSentriLock = false;
      });
  };

  vm.areAppointmentInstructionsInvalid = () =>
    areAppointmentInstructionsInvalid(
      vm.appointmentConfig.access,
      vm.appointmentConfig.instructions,
    );

  vm.resetAccess = () => {
    vm.isSentriLockCodeValid = null;
    Object.keys(vm.instructionToAccess).forEach(name => {
      vm.appointmentConfig.instructions[name] = {};
    });
    if (vm.appointmentConfig.access === vm.originalAccess) {
      vm.appointmentConfig.instructions[vm.originalAccessName] = {
        ...vm.originalInstructions,
      };
    } else if (vm.appointmentConfig.access === 'SentriLockV2') {
      vm.appointmentConfig.instructions.sentrilockv2 = {
        details:
          '**ATTN - OUT OF BOARD AGENTS** please ask LA to provide you Sentriconnect access to lockbox.',
      };
    }
  };

  vm.$onInit = () => {
    // Redirect to Showings Calendar if enabled
    if ($location.search().listingId) {
      return $location.url(
        `/listing/${$location.search().listingId}/showings?${paramaterize({
          action: $routeParams.status,
          appointmentId: $routeParams.appointmentId,
        })}`,
      );
    }

    AppointmentStatusService.initScope(vm);
    AppointmentBookService.getAppointmentDetails(
      $routeParams.appointmentId,
    ).then(data => {
      vm.data = data;

      vm.selectedTime = new Date(vm.data.appointment.time);

      const promises = [
        AppointmentConfigService.getListingAppointmentConfig(
          data.appointment.listingId,
        ),
        AppointmentSearchService.getPermission($routeParams.appointmentId),
      ];

      $q.all(promises)
        .then(([apptConfig, permission]) => {
          vm.appointmentConfig = apptConfig;
          vm.permissions = permission;

          /**
           * Add these access options for the selected option when access in appointment config is one of them.
           */
          const accessLabelMap = {
            SentriLock: {
              label: 'SentriLock 1-Day Code',
              instructionKey: 'sentrilock',
            },
            'SentriLock App': {
              label: 'SentriLock App',
              instructionKey: 'sentrilockapp',
            },
            SentriLockV2: {
              label: 'SentriLock',
              instructionKey: 'sentrilockv2',
            },
            MasterLock: {
              label: 'Master Lock',
              instructionKey: 'masterlock',
            },
            'Supra eKEY': {
              label: 'Supra eKEY',
              instructionKey: 'supraekey',
            },
          };
          if (accessLabelMap[vm.appointmentConfig.access]) {
            const { instructionKey, label } =
              accessLabelMap[vm.appointmentConfig.access];

            vm.instructionToAccess[instructionKey] = {
              id: vm.appointmentConfig.access,
              label,
            };
          }

          vm.originalAccess = vm.appointmentConfig.access || '';
          [vm.originalAccessName] = Object.entries(vm.instructionToAccess).find(
            ([, access]) => vm.originalAccess === access.id,
          );
          vm.originalInstructions = vm.appointmentConfig.access
            ? _.cloneDeep(
                vm.appointmentConfig.instructions[vm.originalAccessName],
              )
            : {};

          vm.listingAgentConfirm =
            vm.newStatus === 'confirm' &&
            vm.appointmentConfig.listingAgentConfirm &&
            vm.appointmentConfig.listingAgentConfirm.enabled;

          if (vm.data.appointment.status === vm.newStatus) {
            vm.error = 'statusAlreadySet';
            ToastService.add({
              message: `This showing has already been ${
                PAST_TENSE_MAP[vm.newStatus]
              }`,
              type: 'warning',
            });
            $location.url(`listing/${vm.data.listing.id}/appointments`);
          } else if (!vm.permissions[vm.newStatus]) {
            vm.error = 'permissionDenied';
          }
        })
        .finally(() => {
          if (vm.newStatus === 'cancel') {
            vm.details.cancelledBy = 'seller';
          }

          if (vm.newStatus === 'confirm') {
            vm.details.instructions = vm.appointmentConfig.instructions;
            vm.details.access = vm.appointmentConfig.access;
          }

          if (
            $routeParams.auto === 'true' &&
            vm.data.appointment.status !== vm.newStatus
          ) {
            vm.setStatus().then(() => {
              if (!vm.error) {
                swal({
                  title: 'Showing Confirmed',
                  type: 'success',
                  confirmButtonText: 'Done',
                });
              }
            });
          } else {
            vm.dataLoaded = true;
          }
        });
    });
  };
}
